import React from "react";

export default function Tag({ text }) {
  return (
    <span
      className="mb-4 text-sm rounded text-cstm-green font-medium"
    >
      {text}
    </span>
  );
}
